<template>
  <div class="px-5">
    <v-data-table :headers="headers" :items="userAccountsList" class="elevation-1">
      <template v-slot:items="props">
        <td class="text-xs-left">
          {{ props.item.description }}
          <br />
          <small>
            <b>Referência:</b>
            {{props.item.default_plan_name}}
          </small>
        </td>
        <td class="text-xs-left">
          {{ props.item.code }}
          <br />
          <small>
            <b>Cod. referência:</b>
            {{props.item.default_plan_code}}
          </small>
        </td>
        <td class="text-xs-center">
          <v-btn flat icon @click="openEditAccPlanDialog(props.item)">
            <v-icon small>edit</v-icon>
          </v-btn>
          <!-- <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> -->
        </td>
      </template>
    </v-data-table>
    <EditAccPlans
      :getAccountPlans="getAccountPlans"
      :editAccPlanDialog="editAccPlanDialog"
      :expenseData="expenseData"
      :closeEditAccPlanDialog="closeEditAccPlanDialog"
    />
  </div>
</template>
<script>
import EditAccPlans from "./EditAccPlans";
export default {
  methods: {
    openEditAccPlanDialog(data) {
      this.expenseData = data;
      this.editAccPlanDialog = true;
    },
    closeEditAccPlanDialog() {
      this.editAccPlanDialog = false;
    }
  },
  components: {
    EditAccPlans
  },
  props: {
    userAccountsList: Array,
    getAccountPlans: Function
  },
  data() {
    return {
      expenseData: {},
      editAccPlanDialog: false,
      headers: [
        {
          text: "Despesa",
          align: "left",
          sortable: false,
          value: "name_user"
        },
        {
          text: "Código da despesa",
          align: "left",
          sortable: false,
          value: "code_user"
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "acions"
        }
      ]
    };
  }
};
</script>